import styled from 'styled-components';

import { IListItem } from 'types';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ListItemContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

interface Props<T> {
  data?: T[];
  ListItem: (props: IListItem<T>) => React.ReactNode;
  ItemSeparator?: () => React.ReactNode;
}

export const CommonList = <T,>({
  ListItem,
  data = [],
  ItemSeparator,
}: Props<T>) => {
  return (
    <Container>
      {data.map((item, index) => {
        return (
          <ListItemContainer key={`list-item-container-${index.toString()}`}>
            {ListItem({ item, index })}
            {index + 1 !== data.length && ItemSeparator
              ? ItemSeparator()
              : null}
          </ListItemContainer>
        );
      })}
    </Container>
  );
};
